const digitRegExp = /\d/;

export function OnlyNumberWithZeroMask(value) {

  const arr = value.split('').map(char => {
    if (digitRegExp.test(char) && value >= 0) {
      return digitRegExp;
    }
  });

  return arr;
}
